import Common from "../../../../../Common";

interface CreateBody {
	pbx_device_template_id: id
}

const Device = class extends Common {
	browse = (companyId: id, templateId: id, userSettingsId: id) =>
		this.get(`/company/${companyId}/templates/usersettings/${templateId}/template/${userSettingsId}/device`)

	browseValid = (companyId: id, templateId: id) =>
		this.get(`/company/${companyId}/templates/usersettings/${templateId}/template/0/device/valid`)

	create = (companyId: id, templateId: id, userSettingsId: id, body: CreateBody) =>
		this.post(`/company/${companyId}/templates/usersettings/${templateId}/template/${userSettingsId}/device`, body)

	delete = (companyId: id, templateId: id, userSettingsId: id, deviceId: id) =>
		this.doDelete(`/company/${companyId}/templates/usersettings/${templateId}/template/${userSettingsId}/device/${deviceId}`)
}

export default Device
